import { render } from "./SliderFootballView.vue?vue&type=template&id=69f6ea17&scoped=true"
import script from "./SliderFootballView.vue?vue&type=script&lang=js"
export * from "./SliderFootballView.vue?vue&type=script&lang=js"

import "./SliderFootballView.vue?vue&type=style&index=0&id=69f6ea17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f6ea17"]])

export default __exports__